import { Card, Divider, Icon } from "@mui/material";
import ConfirmationModal from "components/ConfirmationModal";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Pagination from "components/Pagination";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import Table from "components/Tables/Table";
import Loader from "components/loader";
import DashboardLayout from "layouts/DashboardLayout";
import { useEffect, useState } from "react";
import jobListing from "./components/jobListing";
import { useSnackbar } from "notistack";
import { APP_CONSTANTS } from "App.constant";
import JobAddEdit from "./components/jobAddEdit";
import { useNavigate } from "react-router-dom";

function JobPage() {
    let defaultJobObject = {
        'job_category_id': 0,
        'title': '',
        'image': '',
        'image_url': '',
        'image_name': '',
        'description': '',
        'additional_tags': '',
        'custom_script': '',
        'short_description': '',
        'publish_date': '',
        'seo_title': '',
        'seo_keywords': [],
        'seo_description': '',
        'isNewImage': false,
        'status': 1,
        'isPublishDateChange': false
    }
    const [deleteModel, setDeleteModel] = useState(false);
    const [currentJobData, setCurrentJobData] = useState(defaultJobObject);
    const [noJobImage, setNoJobImage] = useState('');
    const [addEditSection, setAddEditSection] = useState(false);
    const [allJobCategories, setAllJobCategories] = useState([]);
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [isUpdateData, setIsUpdateData] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem('isLoggedIn') === null || localStorage.getItem('isLoggedIn').toString() === 'false') {
            navigate('/', { replace: true });
        }
        getJobConfigData();
    }, []);

    const handleEditItem = (data) => {
        setCurrentJobData(data);
        setIsUpdateData(true);
        setAddEditSection(true);
    };
    const handleDeleteItem = (data) => {
        setCurrentJobData(data);
        setDeleteModel(true);
    };
    const handleDiscardData = () => {
        setIsUpdateData(false);
        setAddEditSection(false);
        setCurrentJobData(defaultJobObject);
        getJobsData(page);
    };

    const getJobConfigData = () => {
        setIsLoading(true);
        const token = "Bearer " + JSON.parse(localStorage.getItem('userData'))['token'];
        fetch(process.env.REACT_APP_API_URL + 'jobs/config-data', {
            method: 'GET',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": token
            }
        })
            .then(response => response.json())
            .then((responseData) => {
                if (responseData.statusCode === 200) {
                    responseData = responseData.data;
                    setAllJobCategories(responseData.categories);
                    defaultJobObject['image_url'] = responseData.no_job_image;
                    setNoJobImage(responseData.no_job_image);
                    getJobsData(page);
                }
                setIsLoading(false);
            })
            .catch(function (error) {
                setIsLoading(false);
            });
    };
    const getJobsData = (pageNumber) => {
        setIsLoading(true);
        const token = "Bearer " + JSON.parse(localStorage.getItem('userData'))['token'];
        fetch(process.env.REACT_APP_API_URL + 'jobs/summary?page=' + pageNumber, {
            method: 'GET',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": token
            }
        })
            .then(response => response.json())
            .then((responseData) => {
                if (responseData.statusCode === 200) {
                    responseData = responseData.data;
                    const finalJobData = jobListing(responseData.jobs, handleEditItem, handleDeleteItem, addEditJob);
                    setColumns(finalJobData.columns);
                    setRows(finalJobData.rows);
                    setTotalCount(responseData.totalCount);
                    setTotalPages(Math.ceil(responseData.totalCount / 10));
                }
                setIsLoading(false);
            })
            .catch(function (error) {
                setIsLoading(false);
            });
    };
    const deleteJob = (jobId) => {
        setIsLoading(true);
        const token = "Bearer " + JSON.parse(localStorage.getItem('userData'))['token'];
        fetch(process.env.REACT_APP_API_URL + 'jobs/delete-job?id=' + jobId, {
            method: 'DELETE',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": token
            }
        })
            .then(response => response.json())
            .then((data) => {
                setCurrentJobData(defaultJobObject);
                const showMessage = data.message;
                let messageVariant = 'error';
                if (data.statusCode === 200) {
                    setDeleteModel(false);
                    getJobsData(1);
                    messageVariant = 'success';
                }
                enqueueSnackbar(APP_CONSTANTS.JOB[showMessage], { variant: messageVariant });
                setIsLoading(false);
            })
            .catch(function (error) {
                setIsLoading(false);
            });
    };
    const addEditJob = (saveUpdateJobData = {}) => {
        setIsLoading(true);
        const token = "Bearer " + JSON.parse(localStorage.getItem('userData'))['token'];
        let url = process.env.REACT_APP_API_URL + 'jobs/save-job';
        let method = "POST";
        if (saveUpdateJobData.id !== undefined) {
            url = process.env.REACT_APP_API_URL + 'jobs/update-job';
        }
        let savingData = new FormData();
        [
            'id',
            'title',
            'image',
            'description',
            'publish_date',
            'job_category_id',
            'additional_tags',
            'custom_script',
            'short_description',
            'seo_title',
            'seo_keywords',
            'seo_description',
            'status',
        ].forEach(key => {
            if (saveUpdateJobData[key] !== undefined) {
                if (key === 'image') {
                    const jobBlob = new Blob([saveUpdateJobData[key]]);
                    savingData.append(key, jobBlob, saveUpdateJobData['image_name']);
                } else if (key === 'seo_keywords') {
                    savingData.append(key, saveUpdateJobData[key].toString());
                } else {
                    savingData.append(key, saveUpdateJobData[key] ?? '');
                }
            }
        });
        savingData.append('isNewImage', saveUpdateJobData['isNewImage'] ?? false);
        savingData.append('isPublishDateChange', saveUpdateJobData['isPublishDateChange'] ?? false);
        fetch(url, {
            method: method,
            body: savingData,
            headers: {
                "Accept": "application/json",
                "Authorization": token
            }
        })
            .then(response => response.json())
            .then((data) => {
                const showMessage = data.message;
                let messageVariant = 'error';
                if (data.statusCode === 200) {
                    setCurrentJobData(defaultJobObject);
                    setIsUpdateData(false);
                    setAddEditSection(false);
                    getJobsData(1);
                    messageVariant = 'success';
                }
                setIsLoading(false);
                enqueueSnackbar(APP_CONSTANTS.JOB[showMessage], { variant: messageVariant });
            })
            .catch((error) => {
                setIsLoading(false);
            });
    };

    return <>
        <DashboardLayout>
            <DashboardNavbar />
            <ConfirmationModal
                show={deleteModel}
                headerTitle={'Delete Job'}
                bodyText={'Do you want to delete job?'}
                closeAction={{
                    color: 'info',
                    title: 'Cancel',
                }}
                confirmAction={{
                    color: 'error',
                    title: 'Confirm',
                }}
                handleClose={() => {
                    setDeleteModel(false);
                    setCurrentJobData(defaultJobObject);
                }}
                handleConfirm={() => {
                    setDeleteModel(false);
                    deleteJob(currentJobData.id);
                }} />
            <SoftBox py={3}>
                <SoftBox mb={3}>
                    <Card>
                        <SoftBox display="flex" justifyContent="space-between" alignItems="center" alignSelf="flex-end" style={{
                            "margin": "16px 16px 0 16px"
                        }}>
                            {
                                !addEditSection ? <>
                                    <SoftButton variant="gradient" color="dark" onClick={() => setAddEditSection(true)}>
                                        <Icon fontSize="default" color="inherit">
                                            add
                                        </Icon>&nbsp;&nbsp;Add Job
                                    </SoftButton>
                                </> : <>
                                    <SoftButton variant="gradient" color="error" onClick={handleDiscardData}>
                                        <Icon fontSize="default" color="inherit">
                                            close
                                        </Icon>&nbsp;&nbsp; Discard
                                    </SoftButton>
                                    &nbsp;&nbsp;
                                    <SoftButton variant="gradient" color="success" onClick={() => addEditJob(currentJobData)}>
                                        <Icon fontSize="default" color="inherit">
                                            check
                                        </Icon>&nbsp;&nbsp; {isUpdateData ? "Update" : "Save"}
                                    </SoftButton>
                                </>
                            }
                        </SoftBox>
                        <Divider flexItem />
                        {
                            !addEditSection ? <>
                                {
                                    !isLoading ? <>
                                        <SoftBox
                                            sx={{
                                                "& .MuiTableRow-root:not(:last-child)": {
                                                    "& td": {
                                                        borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                                                            `${borderWidth[1]} solid ${borderColor}`,
                                                    },
                                                },
                                            }}
                                        >
                                            {
                                                totalCount > 0 ?
                                                    <Table columns={columns} rows={rows} /> :
                                                    <SoftBox display="flex" flexDirection="column" style={{
                                                        "alignItems": "center",
                                                        "margin": "0 16px 16px 16px"
                                                    }}>
                                                        <SoftTypography variant="button" fontWeight="medium">
                                                            No Data Found
                                                        </SoftTypography>
                                                    </SoftBox>
                                            }
                                        </SoftBox>
                                    </> : <>
                                        <Loader classes='black' />
                                    </>
                                }
                                {
                                    !isLoading && totalCount > 0 && <>
                                        <Pagination
                                            maxPages={totalPages}
                                            currentPage={page}
                                            onPageChange={(pageNumber) => {
                                                setPage(pageNumber);
                                                getJobsData(pageNumber);
                                            }} />
                                    </>
                                }
                            </> : <>
                                <JobAddEdit
                                    currentJobData={currentJobData}
                                    allJobCategories={allJobCategories}
                                    noJobImage={noJobImage} />
                            </>
                        }
                        {
                            addEditSection && <>
                                <Divider flexItem />
                                <SoftBox display="flex" justifyContent="space-between" alignItems="center" alignSelf="flex-end" style={{
                                    "margin": "0 16px 16px 16px"
                                }}>
                                    <>
                                        <SoftButton variant="gradient" color="error" onClick={handleDiscardData}>
                                            <Icon fontSize="default" color="inherit">
                                                close
                                            </Icon>&nbsp;&nbsp; Discard
                                        </SoftButton>
                                        &nbsp;&nbsp;
                                        <SoftButton variant="gradient" color="success" onClick={() => addEditJob(currentJobData)}>
                                            <Icon fontSize="default" color="inherit">
                                                check
                                            </Icon>&nbsp;&nbsp; {isUpdateData ? "Update" : "Save"}
                                        </SoftButton>
                                    </>
                                </SoftBox>
                            </>
                        }
                    </Card>
                </SoftBox>
            </SoftBox>
        </DashboardLayout>
    </>;
}

export default JobPage;